import { createStyles } from '../../styles';
export default createStyles((theme, { radius, variant }) => {
    return {
        root: {}
    };
});
